import * as AbtConfigurationRoutes from './abt-configuration.routes';
import { JourneyConstructionRulesController } from './journey-construction-rules/journey-construction-rules.controller';
import { JourneyConstructionRuleManagerController } from './journey-construction-rules/manage-rule/journey-construction-rule-manager.controller';
import { TimebandsController } from './timebands/timebands.controller';
import { ManageTimebandController } from './timebands/manage-timeband/timeband-manager.controller';
import { SpecialDaysController } from './special-days/special-days.controller';

/**
* The entry point the abt-configuration module
*/
export const initialise = () => {
  angular.module('app.abt-configuration', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components'
  ])
  .controller('JourneyConstructionRulesController', <ng.IControllerConstructor>JourneyConstructionRulesController)
  .controller('JourneyConstructionRuleManagerController', <ng.IControllerConstructor>JourneyConstructionRuleManagerController)
  .controller('TimebandsController', <ng.IControllerConstructor>TimebandsController)
  .controller('ManageTimebandController', <ng.IControllerConstructor>ManageTimebandController)
  .controller('SpecialDaysController', <ng.IControllerConstructor>SpecialDaysController);

  AbtConfigurationRoutes.initialise();
};